/** Max characters for target word and each taboo word (AI + manual entry). */
export const MAX_WORD_CHARS = 20;
export const MAX_TABOO_CHARS = 20;

export function clampText(value, maxLen) {
  return String(value ?? "").slice(0, maxLen);
}

export function clampWord(value) {
  return clampText(value, MAX_WORD_CHARS);
}

export function clampTabooWords(taboo) {
  return (Array.isArray(taboo) ? taboo : []).map((t) => clampText(t, MAX_TABOO_CHARS));
}
